var map = {
	"./blog-1.jpg": 68,
	"./blog-2.jpg": 69,
	"./blog-five1.jpg": 120,
	"./blog-five2.jpg": 121,
	"./blog-five3.jpg": 122,
	"./blog-standard-1.jpg": 61,
	"./blog-standard-2.jpg": 115,
	"./blog-standard-3.jpg": 116,
	"./call-action-widget.jpg": 263,
	"./comment-author-1.jpg": 117,
	"./comment-author-2.jpg": 118,
	"./comment-author-3.jpg": 119,
	"./footer-widget-1.jpg": 65,
	"./footer-widget-2.jpg": 66,
	"./hd.jpg": 264,
	"./iit.jpg": 265,
	"./iit.png": 266,
	"./navic-chip.jpg": 267,
	"./navic-clock.jpg": 268,
	"./news-1.jpg": 269,
	"./news-10.jpg": 270,
	"./news-11.jpg": 271,
	"./news-12.jpg": 272,
	"./news-13.jpg": 273,
	"./news-14.png": 274,
	"./news-15.png": 275,
	"./news-16.jpeg": 276,
	"./news-17.jpeg": 277,
	"./news-18.jpeg": 278,
	"./news-19.jpg": 279,
	"./news-2.jpg": 134,
	"./news-3.jpg": 280,
	"./news-4.jpg": 281,
	"./news-5.jpg": 282,
	"./news-6.jpg": 283,
	"./news-7.jpg": 284,
	"./news-8.jpg": 285,
	"./news-9.jpg": 286,
	"./news-author-1.jpg": 287,
	"./news-author-2.jpg": 135,
	"./news-author-3.jpg": 288,
	"./news-bg-two.jpg": 289,
	"./news-bg.jpg": 290,
	"./news-six1.jpg": 136,
	"./news-six2.jpg": 137,
	"./news-six3.jpg": 138,
	"./news-widget-1.jpg": 62,
	"./news-widget-2.jpg": 63,
	"./news-widget-3.jpg": 64,
	"./news1.jpg": 291,
	"./news2.jpg": 292,
	"./news3.jpg": 293,
	"./rit.png": 294,
	"./tele.png": 295
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 67;